import React, { useState } from "react";

const UserCard = ({ user, onEdit, onDelete, index }) => {
  const [editedUser, setEditedUser] = useState({
    username: user.user_name,
    emailId: user.email_id,
    userType: user.user_type,
  });

  const [showEditModal, setShowEditModal] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEditedUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleUpdateClick = async () => {
    try {
      await onEdit(user.user_id, {
        user_name: editedUser.username,
        email_id: editedUser.emailId,
        user_type: editedUser.userType,
      });

      setEditedUser({
        // Reset the editedUser state
        username: user.user_name,
        emailId: user.email_id,
        userType: user.user_type,
      });

      setShowEditModal(false);
      alert("User Updated Successfully");
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  return (
    <>
      <tbody>
        <tr>
          <th scope="row">{index}</th>
          <td>{user.user_name}</td>
          <td>{user.email_id}</td>
          <td>{user.user_type}</td>
          <td>
            <div className="d-flex">
              <span
                className="action-icon"
                data-bs-toggle="modal"
                data-bs-target={`#editModal${user.user_id}`} // Use unique ID for each modal
                onClick={() => setShowEditModal(true)}
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </span>
              <span
                className="action-icon"
                onClick={() => onDelete(user.user_id)}
              >
                <i className="fa-solid fa-trash"></i>
              </span>
            </div>
          </td>
        </tr>
      </tbody>

      <div
        className={`modal fade ${showEditModal ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        aria-labelledby="exampleModalLabel"
        id={`editModal${user.user_id}`}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit User
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Username:</label>
                <input
                  type="text"
                  className="form-control"
                  name="username"
                  value={editedUser.username}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email:</label>
                <input
                  type="email"
                  className="form-control"
                  name="emailId"
                  value={editedUser.emailId}
                  onChange={handleInputChange}
                  disabled
                />
              </div>
              <div className="mb-3">
                <label className="form-label">User Type:</label>
                <input
                  type="text"
                  className="form-control"
                  name="userType"
                  value={editedUser.userType}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setShowEditModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleUpdateClick()}
                data-bs-dismiss="modal"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserCard;
